import React from 'react';
import AddClasseAndLycee from '../../components/organisms/forms/AddClasseAndLycee';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { HeaderText } from '../../components/atoms/Texts/HeaderText';
import emojis from '../../theme/emoji';
import useStyle from './addClasseAndLycee.style';
import logout from '../../graphql/logout';
import { IconButton } from '../../components/atoms/Buttons/IconButton';

const TutoCreateClasse = () => {
  const classes = useStyle();
  return (
    <ContainerFullWidth>
      <div className={classes.topBar}>
        <IconButton onClick={logout} icon={'Logout'} />
      </div>
      <div className={classes.container}>
        <HeaderText
          text="Créons votre lycée et votre classe !"
          emoji={emojis['NerdFace']}
        />
        <AddClasseAndLycee />
      </div>
    </ContainerFullWidth>
  );
};

export default TutoCreateClasse;
